module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-54cfc1174b410dedf2b262a6251080ce.png";